import { WithAuthorization } from "../../context";
import { Card } from "../../components/Card";
import Page from "../../components/Page/Page";
import { useTranslation } from "react-i18next";
import { SupplierDecarbonization } from "./SupplierDecarbonization";

function SupplierNetZeroStrategy() {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierNetZeroStrategy"
  });

  return (
    <Page title={t("page.title")} subTitle={t("page.subTitle")}>
      <Card>
        <SupplierDecarbonization />
      </Card>
    </Page>
  );
}

export default WithAuthorization(SupplierNetZeroStrategy);